import { toggleVisible, toggleNoValidate, toggleDisabled, saveFormState, restoreFormState } from './utils';
import '@/components/validator/validator.plugin';
import scrollto from '@utils/scrollto.js';
export default class RegWidget extends EventTarget {
    constructor(element, options = {}) {
        super();
        this.form = null;
        this.pageIndexValue = 0;
        if (!element)
            throw new Error('undefined element');
        this.element = element;
        this.options = Object.assign(Object.assign({}, RegWidget.defaults()), options);
        this.init();
    }
    static defaults() {
        return {
            baseClass: 'reg',
            storageKey: 'reg',
        };
    }
    init() {
        var _a;
        this.form = this.element.closest('form');
        this.loadFieldsValuesFromStorage();
        (_a = this.form) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', this.handleFormSubmit.bind(this));
        if (this.form) {
            this.form.validator = new Validator(this.form);
        }
        this.pageIndex = 0;
        document.addEventListener('click', this.handleDocumentClick.bind(this), true);
        this.element.querySelectorAll('input[data-nomination]').forEach((input) => {
            input.addEventListener('change', () => {
                this.updateNominationPageState(input, true);
            });
        });
    }
    handleDocumentClick(event) {
        const target = event.target;
        const btnPrev = target === null || target === void 0 ? void 0 : target.closest(`.${this.options.baseClass}__btn-prev`);
        const btnNext = target === null || target === void 0 ? void 0 : target.closest(`.${this.options.baseClass}__btn-next`);
        if (btnPrev) {
            this.prev();
        }
        if (btnNext) {
            const valid = this.validate();
            if (valid) {
                this.next();
            }
        }
    }
    handleFormSubmit(event) {
        if (this.validate()) {
            this.next();
        }
        else {
            event.preventDefault();
        }
    }
    scrollToFirstError() {
        const firstInvalidField = this.element.querySelector('.is-invalid');
        if (firstInvalidField) {
            scrollto(firstInvalidField, { duration: 700, offset: 40 });
        }
    }
    validateNominations() {
        return true;
    }
    validate() {
        if (!this.form || !this.form.validator)
            return false;
        const validator = this.form.validator;
        validator.reinit();
        const valid = validator.validate(undefined, false) && this.validateNominations();
        if (!valid) {
            this.scrollToFirstError();
        }
        else {
            this.saveFieldsValuesToStorage();
        }
        return valid;
    }
    get pageIndex() {
        return this.pageIndexValue;
    }
    set pageIndex(value) {
        this.pageIndexValue = value;
        this.updateState();
    }
    getPagesCount() {
        var _a;
        return (_a = this.element.querySelectorAll(`.${this.options.baseClass}__page.is-active`).length) !== null && _a !== void 0 ? _a : 0;
    }
    isLastStep() {
        return this.pageIndex === this.getPagesCount();
    }
    saveFieldsValuesToStorage() {
        var _a;
        const key = (_a = this.options.storageKey) !== null && _a !== void 0 ? _a : '';
        if (this.form && key) {
            saveFormState(this.form, key);
        }
    }
    loadFieldsValuesFromStorage() {
        var _a;
        const key = (_a = this.options.storageKey) !== null && _a !== void 0 ? _a : '';
        if (this.form && key) {
            restoreFormState(this.form, key);
        }
    }
    resetStorage() {
        var _a;
        const key = (_a = this.options.storageKey) !== null && _a !== void 0 ? _a : '';
        if (key) {
            localStorage.removeItem(key);
        }
    }
    updateNominationPageState(input, updateWidgetState = false) {
        var _a;
        if (!input)
            return;
        const nominationCode = (_a = input.getAttribute('data-nomination')) !== null && _a !== void 0 ? _a : '';
        if (nominationCode) {
            const page = this.element.querySelector(`.${this.options.baseClass}__page[data-nomination="${nominationCode.trim()}"]`);
            if (page) {
                page.classList.toggle('is-active', input.checked);
                if (updateWidgetState) {
                    this.updateState();
                }
            }
        }
    }
    updateState() {
        const btnBack = this.element.querySelector(`.${this.options.baseClass}__btn-back`);
        const btnPrev = this.element.querySelector(`.${this.options.baseClass}__btn-prev`);
        const btnNext = this.element.querySelector(`.${this.options.baseClass}__btn-next`);
        const parentContainer = this.element.closest('.reg-view__main');
        if (parentContainer) {
            parentContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.element.querySelectorAll(`.${this.options.baseClass}__page`).forEach((page) => {
            page.classList.toggle('is-active', !page.hasAttribute('data-nomination'));
            page.classList.remove('is-valid');
            toggleVisible(page, false);
            toggleNoValidate(page, true);
        });
        this.element.querySelectorAll('input[data-nomination]').forEach((input) => {
            this.updateNominationPageState(input, false);
        });
        this.element.querySelectorAll(`.${this.options.baseClass}__page.is-active`).forEach((page, index) => {
            var _a;
            const isActive = index === this.pageIndex;
            toggleVisible(page, isActive);
            toggleNoValidate(page, !isActive);
            if (isActive) {
                const stepNumber = (_a = page.getAttribute('data-step')) !== null && _a !== void 0 ? _a : '1';
                const stepEl = this.element.querySelector('[data-step-number]');
                if (stepEl) {
                    stepEl.textContent = stepNumber;
                }
            }
        });
        toggleVisible(btnBack, true);
        toggleVisible(btnPrev, false);
        toggleDisabled(btnNext, false);
        btnNext === null || btnNext === void 0 ? void 0 : btnNext.setAttribute('type', 'button');
        if (this.isLastStep()) {
            btnNext === null || btnNext === void 0 ? void 0 : btnNext.setAttribute('type', 'submit');
        }
        if (this.pageIndexValue > 0) {
            toggleVisible(btnBack, false);
            toggleVisible(btnPrev, true);
        }
        if (this.pageIndex === 1) {
            const checkedNominationsNumber = this.element.querySelectorAll('input[data-nomination]:checked').length;
            toggleDisabled(btnNext, checkedNominationsNumber === 0);
        }
    }
    nav(index) {
        if (index < 0) {
            this.pageIndex = 0;
        }
        if (!this.isLastStep()) {
            this.pageIndex = index;
        }
    }
    prev() {
        this.nav(this.pageIndex - 1);
    }
    next() {
        this.nav(this.pageIndex + 1);
    }
    resetForm() {
        var _a;
        this.resetStorage();
        (_a = this.form) === null || _a === void 0 ? void 0 : _a.reset();
        setTimeout(() => {
            this.pageIndex = 0;
        }, 0);
    }
}
